import { STUDENT } from './Base';

export const onGetStudentRequest = (params = {}, cb) => ({ params, cb, type: STUDENT.GET_REQUEST });
export const onGetStudentSuccess = (payload = {}, cb) => ({ payload, type: STUDENT.GET_SUCCESS, cb });
export const onGetStudentFailure = (payload = {}, cb) => ({ payload, type: STUDENT.GET_FAILURE, cb });